<template>
  <q-list :dense="dense" :padding="padding" :separator="separator">
    <slot />
  </q-list>
</template>

<script>
export default {
  name: 'List',
  props: {
    dense: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: Boolean,
      default: false,
    },
    separator: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
